import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    color: theme.palette.text.primary,
    cursor: 'pointer',
  },
  sectionTitle: {
    fontSize: theme.spacing(3),
    fontWeight: 700,
  },
  favoriteTaskContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1.5),
    height: theme.spacing(17.5),
    width: theme.spacing(26),
    padding: theme.spacing(2),
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)',
      cursor: 'pointer',
    },
  },
  favoriteTasksContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  favoriteTaskTitle: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: theme.spacing(2),
    fontWeight: 700,
  },
}));
